export default {
  save: 'Išsaugoti',
  reset: 'Atstatyti',
  close: 'Uždaryti',
  create: 'Sukurti',
  delete: 'Ištrinti',
  ok: 'Gerai',
  yes: 'Taip',
  search: 'Paieška',
  no: 'Ne',
  price: 'Kaina',
  city: 'Miestas',
  language: 'Kalba',
  selectedDate: 'Pasirinkta Data',
  selectedDateRange: 'Pasirinkti Datų Rėžiai',
  discardChanges: 'Panaikinti Pakeitimus?',
  discardChangesBody: 'Yra neišsaugotų pakeitimų. Ar tikrai išeiti neišsaugant?',
  discardChangesBodyContinue: 'Yra neišsaugotų pakeitimų. Ar tikrai tęsti neišsaugant?',
  monday: 'Pirmadienis',
  tuesday: 'Antradienis',
  wednesday: 'Trečiadienis',
  thursday: 'Ketvirtadienis',
  friday: 'Penktadienis',
  required: 'Privalomas Laukas',
  count: 'Kiekis',
  tooFew: 'Per Mažai',
  confirm: 'Patvirtinti',
  cancel: 'Atšaukti',
  amount: 'Suma',
  comment: 'Komentaras',
  newCashEntry: 'Naujas Įnašas',
  balanceNotSufficient: 'Nepakankamas balansas',
  invalidFields: 'Formoje yra neteisingai užpildytų laukų: {fields}',
  'forMonth-0': 'Sausio',
  'forMonth-1': 'Vasario',
  'forMonth-2': 'Kovo',
  'forMonth-3': 'Balandžio',
  'forMonth-4': 'Gegužės',
  'forMonth-5': 'Birželio',
  'forMonth-6': 'Liepos',
  'forMonth-7': 'Rugpjūčio',
  'forMonth-8': 'Rugsėjo',
  'forMonth-9': 'Spalio',
  'forMonth-10': 'Lapkričio',
  'forMonth-11': 'Gruodžio',
  'forDay-1': 'Pirmadienio',
  'forDay-2': 'Antradienio',
  'forDay-3': 'Trečiadienio',
  'forDay-4': 'Ketvirtadienio',
  'forDay-5': 'Penktadienio',
  'forDay-monday': 'Pirmadienio',
  'forDay-tuesday': 'Antradienio',
  'forDay-wednesday': 'Trečiadienio',
  'forDay-thursday': 'Ketvirtadienio',
  'forDay-friday': 'Penktadienio',
};
